// extracted by mini-css-extract-plugin
export default {"configTitle":"braselect-module-configTitle-jVibs","error":"braselect-module-error-dlCnr"};